import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PermissionEnum} from "@app/enums/permissions/PermissionEnum";
import {SideMenuEnum} from "@app/enums/SideMenuEnum";

@Component({
  selector: 'app-sidebar-toggle-item',
  templateUrl: './sidebar-toggle-item.component.html',
  styleUrl: './sidebar-toggle-item.component.scss',
  standalone: false
})
export class SidebarToggleItemComponent {
  @Input() icon!: string;
  @Input() label!: string;
  @Input() title!: string;
  @Input() permission!: PermissionEnum;
  @Input() isShrunk = false;
  @Input() isExpanded = false;
  @Input() notificationCount: number = 0;
  @Input() notificationTooltip: string = '';

  @Input() menuKey!: SideMenuEnum;
  @Output() toggled = new EventEmitter<SideMenuEnum>();

  onClick(): void {
    this.toggled.emit(this.menuKey);
  }
}
